// Copyright (c) 2017 Deere & Company

import SearchFilters from '../state/search-filters';
import actions from '../../action-list';
import {getDefaultState} from '../state';

const updateSearchFilters = (state, action) =>
    SearchFilters.update(state, {
        [action.property]: {
            $set: action.payload
        }
    });

const actionTypes = {
    [actions.UPDATE_CLAIM_SEARCH_FILTER_BY]: updateSearchFilters,
    [actions.UPDATE_CLAIM_SEARCH_SORT_BY]: updateSearchFilters,
    [actions.UPDATE_CLAIM_SEARCH_SORT_DIRECTION]: updateSearchFilters
};

export default (state = getDefaultState().searchFilters, action) => {

    const reducer = actionTypes[action.type];

    return reducer ?
        reducer(state, action) :
        state;

};



// WEBPACK FOOTER //
// ./src/claim/claim-search/reducers/search-filters.js